import { Pipe, PipeTransform } from '@angular/core';
import { isFunction } from 'lodash-es';
import { AvanoButtonBarButtonDetails, DynamicAvanoButtonBarButtonDetails } from '../avano-button-bar.common';

@Pipe({
  name: 'triggeredReEvaluate',
  pure: true
})
export class TriggeredReEvaluatePipe implements PipeTransform {
  transform(dynamicButtonDetails: DynamicAvanoButtonBarButtonDetails[], triggers: any[]): AvanoButtonBarButtonDetails[] {
    if (!dynamicButtonDetails) throw new Error("Invalid Argument, dynamicButtonDetails are falsy");
    const staticButtonDetails = dynamicButtonDetails.map(buttonDetails => this.evaluateFunctions(buttonDetails));
    return staticButtonDetails; 
  }

  private evaluateFunctions(dynamicButtonDetails: DynamicAvanoButtonBarButtonDetails): AvanoButtonBarButtonDetails {
    const staticButtonDetails: AvanoButtonBarButtonDetails = {
      icon: isFunction(dynamicButtonDetails.icon) ? dynamicButtonDetails.icon() : dynamicButtonDetails.icon, 
      label: isFunction(dynamicButtonDetails.label) ? dynamicButtonDetails.label() : dynamicButtonDetails.label, 
      group: isFunction(dynamicButtonDetails.group) ? dynamicButtonDetails.group() : dynamicButtonDetails.group, 
      isCallToActionButton: isFunction(dynamicButtonDetails.isCallToActionButton) ? dynamicButtonDetails.isCallToActionButton() : dynamicButtonDetails.isCallToActionButton, 
      isDisabled: isFunction(dynamicButtonDetails.isDisabled) ? dynamicButtonDetails.isDisabled() : dynamicButtonDetails.isDisabled, 
      noTranslate: isFunction(dynamicButtonDetails.noTranslate) ? dynamicButtonDetails.noTranslate() : dynamicButtonDetails.noTranslate, 
      action: dynamicButtonDetails.action,
      errorDetails: dynamicButtonDetails.errorDetails
    };
    return staticButtonDetails;
  }
}
